import React from 'react'

interface ListLoaderProps {
  message?: string
  className?: string
}

/**
 * Consistent loading indicator for list pages and data tables.
 * Matches the loader pattern used across reports for a unified look.
 */
export const ListLoader: React.FC<ListLoaderProps> = ({ message, className }) => {
  return (
    <div className={`p-12 text-center ${className ?? ''}`.trim()}>
      <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      <p className="mt-4 text-muted-foreground">{message ?? 'Loading...'}</p>
    </div>
  )
}
